import { InitOptions } from 'i18next';
import { formatDateValueUTC, formatShortDateValue } from './utils/formatDate';
import { formatNumber } from './utils/formatNumber';
import sanitizeDateResponse from './utils/sanitizeDateResponse';

const i18nConfig: InitOptions = {
  whitelist: ['en', 'en-GB', 'en-US', 'en-AU'],
  fallbackLng: 'en',
  ns: ['common'],
  defaultNS: 'common',
  keySeparator: false,
  debug: false,

  interpolation: {
    format: (value: string, format?: string, lng?: string): string => {
      if (format === 'dateUTC' && lng) {
        return `${formatDateValueUTC(sanitizeDateResponse(value), lng)}`;
      }
      if (format === 'shortDateUTC' && lng) {
        return `${formatShortDateValue(sanitizeDateResponse(value), lng)}`;
      }
      if (format === 'number' && lng) {
        return `${formatNumber(value, lng)}`;
      }
      return value;
    },
    escapeValue: false, // not needed for react!!
  },
};

export default i18nConfig;
